import React, { Component } from 'react';
import { Col, Input, Modal, Row, Typography } from 'antd';
import AddImage from '../common/AddImage';
import { connect } from 'react-redux';
import actions from '../../redux/actions/setting_data/index';
import * as yup from 'yup'
import utils from '../../common/utils'
import { forEach } from 'lodash'

const { TextArea } = Input;
const { Text } = Typography;

let schema = yup.object().shape({
  icon_image: yup.string().required("Thêm biểu tượng").trim(),
  transaction_explorer: yup.string().required("Nhập lối mã giao dịch").trim(),
})
class PopupAddCoins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleConfirm: false,
      deleteInform: false,
      transaction_tx_path: '',
      imageUrl: '',
      errors: {},
      data: {
        coin: '',
        contract_address: '',
        icon_image: '',
        name: '',
        symbol: '',
        decimal: '',
        minimum_withdrawal: 0,
        transaction_explorer: '',
        fee: 0,
        type: '',
        confirmation: 0,
        
      },
    };
  }

  handleOk =  (e) => {
    let data = {
      // ...this.state.data,
      coin: this.props.rowUpdate?.coin,
      type: this.props.rowUpdate?.type,
      name: this.props.rowUpdate?.name,
      symbol: this.props.rowUpdate?.symbol,
      transaction_explorer:  this.state.transaction_tx_path,
      confirmation:  parseFloat(this.state.confirmation),
      contract_address:  this.props.contractAddress,
      icon_image: this.state.imageUrl,
      // fee: parseFloat(this.state.data.fee),
    }
    schema.validate(data, {abortEarly: false})
    .then(value => this.setState({ visibleConfirm: true, data: value, }))
    .catch(error => {
      let errors = {};
			forEach(error.inner, (err) => {
				errors[err.path] = err.message;
			});
			this.setState({errors});
    })
  };

  handleCancel = (e) => {
    this.props.closePopup(false);
  };

  handleOkConfirm = (e) => {
    this.props.closePopup(false);
    if(this.props.coinNames === "ETH"){
      this.props.postCoinSetting(this.state.data, () => utils.showNotification('Thông báo', 'Thành công!'));
    } else if(this.props.coinNames === "TOMO"){
      this.props.fetchTomoCoin(this.state.data);
    }
 
    
    this.handleCancelConfirm()

    // todo refactor this
    this.props.__INIT__();
  };

  handleCancelConfirm = (e) => {
    this.setState({
      visibleConfirm: false,
    });
  };

  handleImage = (imageUrl) => {
    this.setState({
      imageUrl
    });
  };

  onChangePathCoin = ({ target: { value: transaction_tx_path } }) => {
    this.setState({ transaction_tx_path });
    
  }
  onConfirmation = ({ target: { value: confirmation } }) => {
    this.setState({ confirmation });
  };

  render() {
    const { errors } = this.state
    return (
      <div>
        <Modal
          width="700px"
          className={'popup-add-coin'}
          title={<h3 style={{ marginBottom: 0 }}>Tạo đồng mới</h3>}
          visible={this.props.isVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          cancelText={'Hủy'}
          okText={this.props.rowUpdate ? 'Xác nhận' : 'Tạo'}
        >
          <Row>
            <Col span={10}>
              <div>Đồng</div>
              <Input
                placeholder="Đồng"
                value={this.props.rowUpdate?.coin || ''}
                disabled={true}
              />
            </Col>
            <Col span={10} offset={4}>
              <div>Tên đầy đủ</div>

              <Input
                placeholder="Tên đầy đủ"
                disabled={true}
                value={this.props.rowUpdate?.name || ''}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={10}>
              <div>Mạng</div>

              <Input
                placeholder="Mạng"
                disabled={true}
                value={this.props.rowUpdate?.type || ''}
              />
            </Col>
            <Col span={10} offset={4}>
              <div>Đơn vị</div>
              <Input
                placeholder="Đơn vị"
                disabled={true}
                value={this.props.rowUpdate?.coin || ''}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={10}>
              <div>Lối mã giao dịch</div>
              <Input
                placeholder="Lối mã giao dịch"
                onChange={this.onChangePathCoin}
              />
              <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors.transaction_explorer || '')}</Text>
              </div>
            </Col>
            <Col span={10} offset={4}>
              <div>Số lượng xác nhận</div>
              <Input
                name="confirmation"
                onChange={this.onConfirmation}
                placeholder="Số lượng xác nhận"
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={4}>
              <div>Biểu tượng</div>
              <div>
                <AddImage
                  handleImage={this.handleImage}
                  imageUrl={this.props.rowUpdate?.icon_image}
                />
              </div>
              <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors.icon_image || '')}</Text>
                </div>
            </Col>
            <Col span={5} offset={1}>
              <div>Ghi chú</div>

              <TextArea rows={3} />
            </Col>
          </Row>
        </Modal>
        {/* confirm */}
        <Modal
          visible={this.state.visibleConfirm}
          onOk={this.handleOkConfirm}
          onCancel={this.handleCancelConfirm}
          cancelText={'Hủy'}
          okText={'Xác nhận'}
        >
          <div>Bạn có chắc muốn lưu thông tin?</div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  __INIT__: () => {
    dispatch({ type: '@@__INIT__' });
  },
  postCoinSetting: (params) => {
    dispatch(actions.postCoinSetting(params));
  },
  fetchTomoCoin: (params) => {
    dispatch(actions.fetchTomoCoin(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(PopupAddCoins);
